import { createSlice } from "@reduxjs/toolkit";
import { getLettersText } from "../../utils/functions";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    userInfo: localStorage.getItem("oktaUserInfo")
      ? JSON.parse(localStorage.getItem("oktaUserInfo"))
      : null,
  },
  reducers: {
    setAuthState: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    
    setUserInfo: (state, action) => {
      const profilePic = "";
      const userInfo = action.payload.accountInfo;
      const firstName = userInfo?.name?.split(" ")[0];
      let userDivisionCode = userInfo?.idTokenClaims?.userdivision;
      const userGroupInfo = userInfo?.idTokenClaims?.groups;
      const userEmail = userInfo?.username;
      const sortedDivisions = getSortedDivAuths(userGroupInfo);
      
      // If userDivisionCode is not in sortedDivisions, assign first divisionCode from sortedDivisions
      if (!sortedDivisions.some(div => div.userDivCode === userDivisionCode)) {
        userDivisionCode = sortedDivisions.length > 0 ? sortedDivisions[0].userDivCode : "";
      }

      const userRoles = getRolesForDivision(sortedDivisions, userDivisionCode);     
      const userInfoObject = JSON.stringify(
        Object.assign({}, userInfo, {
          abbr: getLettersText(`${firstName} ${userInfo?.name?.split(" ").pop()}`),
          profilePicture: profilePic,
          userDivCode: userDivisionCode,
          userDivisionName: userInfo?.userdivisionName,
          userRoles: userRoles,
          divisions: sortedDivisions,
          userGroups: userGroupInfo,
          email: userEmail,
        })
      );
      const objectInfo = JSON.parse(userInfoObject);
      state.userInfo = objectInfo;
      //rename to entraUserInfo
      localStorage.setItem("oktaUserInfo", userInfoObject);
    },

    setMsalToken: (state, action) => {
      const existintToken = localStorage.getItem("msalToken")
      const token = action.payload.silentToken
      if (existintToken != token || !existintToken) {
        localStorage.setItem("msalToken", token);
      }
    },
    setAuthDivision: (state, action) => {
      const userInfo = JSON.parse(localStorage.getItem("oktaUserInfo"));
      const userRoles = getRolesForDivision(
        userInfo?.divisions,
        action.payload.code
      );
      const stateObject = Object.assign({}, userInfo, {
        userDivCode: action.payload.code,
        userdivisionName: action.payload.name,
        userRoles: userRoles,
      });
      state.userInfo = stateObject;
      // the next line keep the change of division
      localStorage.setItem("oktaUserInfo", JSON.stringify(stateObject));
    },

  },
});

function getRolesForDivision(divisions, divisionCode) {
  const division = divisions.find((div) => div.userDivCode === divisionCode);
  if (division) {
    return division.roles;
  }
  return [];
}

function getRoleFromGroup(groupCodes) {
  const codes = groupCodes.map((c) => c.toUpperCase());
  if (codes.includes("APP") && codes.includes("ADMIN")) return "AppAdmin";
  if (codes.includes("DIV") && codes.includes("ADMIN")) return "DivisionAdmin";
  if (codes.includes("USER") && codes.includes("RW")) return "Concierge";
  if (codes.includes("RO")) return "Reports";
  return "None";
};  

export const getSortedDivAuths = (userGroupInfo) => {
  const currentEnv = process.env.REACT_APP_RBAC_ENV?.toUpperCase();
  let divAuths = userGroupInfo?.reduce((acc, group) => {
    const parts = group.split("-");
    if (parts.length > 5) {
      const groupDivision = parts[4]?.toUpperCase();
      const groupEnv = parts[5]?.toUpperCase();
      if (groupEnv === currentEnv) {
        const existingDivision = acc.find((div) => div.userDivCode === groupDivision);
        if (existingDivision) {
          existingDivision.roles.push(getRoleFromGroup(parts.slice(2,4)));
        } else {
          acc.push({
            userDivCode: groupDivision,
            roles: [getRoleFromGroup(parts.slice(2,4))],
          });
        }
      }
    }
    return acc;
  }, []);
  

  divAuths.sort((a, b) => {
    if (a.userDivCode < b.userDivCode) return -1;
    if (a.userDivCode > b.userDivCode) return 1;
    return 0;
  }
  );
  return divAuths;
}

export const getAuth = (state) => state.auth;
export const { setAuthState, setUserInfo, setAuthDivision, setMsalToken } = authSlice.actions;
export default authSlice.reducer;
